import { IS_SMALL_SCREEN } from '@Constants/LeftDrawer';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components/native';

import BuyFlow from './BuyFlow/CheckoutCore';
import ProductCarouselCard from './Carousel/ProductCarouselCard';
import ProductDescriptionCard from './Description/ProductDescriptionCard';
import ProductDetailCard from './Detail/ProductDetailCard';

import { useCheckoutStore } from '~stores/checkout';

const StyledProductDetailPanelWrapper = styled.View`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: 100%;
  background-color: ${OwnableTheme.colors.white};
`;

const OrderBackground = styled.View<{ inOrder: boolean }>`
  background-color: ${({ inOrder }) => (inOrder ? '#F3F3F3' : '#FFFFFF')};
`;

const StyledInnerContentContainer = styled.View`
  padding-left: ${IS_SMALL_SCREEN ? '0px' : '40px'};
  padding-right: ${IS_SMALL_SCREEN ? '0px' : '40px'};
`;

const ProductDetailPanel: FC = () => {
  const { uiShowBuyFlow } = useCheckoutStore();

  return (
    <StyledProductDetailPanelWrapper>
      <StyledInnerContentContainer>
        <ProductCarouselCard />
        <ProductDetailCard />
      </StyledInnerContentContainer>
      <OrderBackground inOrder={uiShowBuyFlow}>
        <StyledInnerContentContainer>
          {uiShowBuyFlow ? (
            <BuyFlow />
          ) : (
            <>
              {/* <ProductActionsCard /> */}
              <ProductDescriptionCard />
            </>
          )}
        </StyledInnerContentContainer>
      </OrderBackground>
    </StyledProductDetailPanelWrapper>
  );
};

export default observer(ProductDetailPanel);
